/**
 * This file contains utilities for shape transformations
 * */

const isObjectEqualShallow = (a, b) => {
  const keys = Object.keys(a);
  if (keys.length !== Object.keys(b).length) return false;

  for (let i = 0; i < keys.length; i += 1) {
    if (a[keys[i]] !== b[keys[i]]) return false;
  }
  return true;
};

const checkIsArrayEqualByKey = (array1, array2, key) => {
  if (!Array.isArray(array1) || !Array.isArray(array2)) {
    return true;
  }

  if (array1.length !== array2.length) {
    return false;
  }

  let isArrayEqual = true;

  for (let i = 0; i < array1.length; i += 1) {
    if (!isArrayEqual) {
      return false;
    }
    const foundItemIdx = array2.findIndex((ele) => ele[key] === array1[i][key]);
    if (foundItemIdx < 0) {
      isArrayEqual = false;
      break;
    }
  }

  return isArrayEqual;
};

/** obj should always be serializable */
const cloneDeep = (obj) => {
  let clone;
  try {
    clone = JSON.parse(JSON.stringify(obj));
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
  return clone;
};

const getArrayFromNToM = (n, m) => {
  let res = [];
  for (let i = n; i <= m; i += 1) {
    res = [...res, i];
  }

  return res;
};

const renameArrObjectKeys = (arr, keyNames) => arr.map((obj) => {
  const newObj = { ...obj };
  Object.keys(keyNames).forEach((key) => {
    newObj[keyNames[key]] = obj[key];
    delete newObj[key];
  });
  return newObj;
});

const removeObjectProperty = (obj, propToRemove) => {
  const { [propToRemove]: removed, ...rest } = obj;
  return rest;
};

const isEmptyObject = (value) => Object.keys(value).length === 0 && value.constructor === Object;

const checkObjectHasValue = (value = {}) => {
  const values = Object.values(value);
  if (values.length === 0) {
    return false;
  }
  return !values.find((val) => val);
};

const isEquals = (value, other) => {
  if (value === undefined || value === null || other === undefined
    || other === null || typeof value !== typeof other) {
    return false;
  }

  switch (typeof value) {
    case 'string':
    case 'number':
    case 'boolean':
      return value === other;
    case 'object': {
      if (Array.isArray(value)) {
        return (value.length === 0 && other.length === 0) || (value.length === other.length
          && !value.find((val) => !other.find((otherVal) => isEquals(val, otherVal))));
      }
      const valueKeys = Object.keys(value);
      const otherKeys = Object.keys(other);

      return valueKeys.length === otherKeys.length
        && !valueKeys.find((valueKey) => !isEquals(value[valueKey], other[valueKey]));
    }

    default:
      return false;
  }
};

const convertArrayToObject = (arr) => {
  const updatedObj = {};
  arr.forEach((key) => {
    updatedObj[key] = true;
  });
  return updatedObj;
};

export {
  isObjectEqualShallow,
  cloneDeep,
  getArrayFromNToM,
  renameArrObjectKeys,
  removeObjectProperty,
  isEmptyObject,
  checkIsArrayEqualByKey,
  checkObjectHasValue,
  isEquals,
  convertArrayToObject,
};
